import { render } from "./sclfdzManager.vue?vue&type=template&id=b5e0088a"
import script from "./sclfdzManager.vue?vue&type=script&lang=js"
export * from "./sclfdzManager.vue?vue&type=script&lang=js"

import "./sclfdzManager.vue?vue&type=style&index=0&id=b5e0088a&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__